module.exports = __webpack_public_path__ + "img/icon-house-white.f8edce2b.svg";